import { HOTEL_POSITION_ENUM } from 'app/components/commons/BookingContact/Utils';

export const EXTRANET_CONTACTS_FIELD = 'extranetContacts';

export type EmailTypeKey =
  | 'bookingConfirmationEmails'
  | 'stockInventoryEmails'
  | 'billingEmails';

export type ExtranetContact = {
  email?: string;
  position?: string;
  bookingConfirmationEmails?: boolean;
  stockInventoryEmails?: boolean;
  billingEmails?: boolean;
};

export type EmailTypeColumn = {
  key: EmailTypeKey;
  label: string;
  required?: boolean;
};

export const EMAIL_TYPE_COLUMNS: EmailTypeColumn[] = [
  {
    key: 'bookingConfirmationEmails',
    label: 'Booking Confirmation Emails',
    required: true,
  },
  {
    key: 'stockInventoryEmails',
    label: 'Stock /\nInventory\nEmails',
    required: true,
  },
  { key: 'billingEmails', label: 'Billing\nEmails' },
];

export const POSITION_OPTIONS = HOTEL_POSITION_ENUM.map((position) => ({
  label: position,
  value: position.toLowerCase(),
}));

export const DEFAULT_EXTRANET_CONTACT: ExtranetContact = {
  bookingConfirmationEmails: true,
  stockInventoryEmails: true,
  billingEmails: false,
};

export const INITIAL_EXTRANET_CONTACTS: ExtranetContact[] = [
  DEFAULT_EXTRANET_CONTACT,
];
